import React, { FC } from 'react';
import { SelectField, SelectFieldProps } from 'react-admin';

export const AppSelectField: FC<SelectFieldProps> = React.memo((props) => {
  return <SelectField {...props} emptyText="-" />;
});
